module.exports = __webpack_public_path__ + "img/boats.44b505f1.png";